import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';

import { VppApplicationsStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { VppApplication, VppAssetListComponent } from '@rocksoft/shared';

@Component({
  selector: 'ml-mdm-vpp-asset-list',
  templateUrl: './vpp-asset-list.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [VppAssetListComponent],
})
export class VppAssetListContainerComponent {
  private readonly store = inject(Store);

  public readonly selectedAssetChange = output<VppApplication>();

  public readonly vppAssets = this.store.selectSignal(VppApplicationsStoreSelectors.selectAllVppApplications);

  public selectedAssetChanged(asset: VppApplication) {
    this.selectedAssetChange.emit(asset);
  }
}
